/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-15 12:30:47
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-15 13:02:13
 * @Description: loading公共类
 * @FilePath: \hsylc2021\src\utils\loading.js
 */
import Vue from 'vue';
import Loading from '../components/Loading';
export default class {
  constructor(options) {
    this.init(options);
  }
  init(options) {
    this.options = { ...options };
    const LoadingConstructor = Vue.extend(Loading);
    this.instance = new LoadingConstructor();
    this.vm = this.instance.$mount();
    this.$el = this.vm.$el;
    this.dom = this.$el;
    this.dom.style.zIndex = 1100;
    this.hide();
    document.body.appendChild(this.$el);
  }
  show() {
    this.dom.style.display = 'block';
  }
  hide() {
    this.dom.style.display = 'none';
  }
}
